import { PORTAL_LIGHTBOX_PRIORITY } from '@rsos/capstone/src/constants/portalPriorities';
import { Modal } from '@rsos/components/capstone/base';
import { ModalBody } from '@rsos/components/capstone/base/Modal/ModalComponents';

const EnlargedImageModal = ({
  isImageModalActive,
  onClose,
  enlargedImageUrl,
}) => {
  return (
    <Modal
      id="card-image-modal"
      portalPriority={PORTAL_LIGHTBOX_PRIORITY}
      isOpened={isImageModalActive}
      onClose={onClose}
      width="75%"
      overflowY="auto"
    >
      <ModalBody onClose={onClose}>
        <img src={enlargedImageUrl} />
      </ModalBody>
    </Modal>
  );
};

export default EnlargedImageModal;
